const provinces = [
  {
    nsi: "04000",
    type: "province",
    color: "#aaffc3",
    name: { fr: "Bruxelles capitale", nl: "Brussel Hoofstadt" },
    chiefTown: { fr: "Bruxelles", nl: "Brussel" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/7/7a/Blason_de_Bruxelles-Capitale.svg",
    wikipedia: "Région_de_Bruxelles-Capitale",
    region: "Région Bruxelles-Capitale",
    facts: {
      population: 1183545,
      surface: 161.38
    },
    children: [
      "21000",
      "21001",
      "21002",
      "21003",
      "21004",
      "21005",
      "21006",
      "21007",
      "21008",
      "21009",
      "21010",
      "21011",
      "21012",
      "21013",
      "21014",
      "21015",
      "21016",
      "21017",
      "21018",
      "21019"
    ]
  },
  {
    nsi: "10000",
    type: "province",
    color: "#3cb44b",
    name: { fr: "Anvers", nl: "Antwerpen" },
    chiefTown: { nl: "Antwerpen", fr: "Anvers" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/0/09/Wapen_van_de_provincie_Antwerpen.svg",
    wikipedia: "Province_d%27Anvers",
    region: "Région Flamande",
    facts: {
      population: 1781904,
      surface: 2867
    },
    children: [
      "12030",
      "12034",
      "11000",
      "11001",
      "11002",
      "11004",
      "11005",
      "11007",
      "11008",
      "11009",
      "11013",
      "11016",
      "11018",
      "11021",
      "11022",
      "11023",
      "11024",
      "11025",
      "11057",
      "11029",
      "11030",
      "11035",
      "11037",
      "11038",
      "11039",
      "11040",
      "11044",
      "11050",
      "11052",
      "11053",
      "11054",
      "11055",
      "11056",
      "12000",
      "12002",
      "12005",
      "12007",
      "12009",
      "12014",
      "12021",
      "12025",
      "12026",
      "12029",
      "12041",
      "12035",
      "12040",
      "13000",
      "13001",
      "13002",
      "13003",
      "13004",
      "13006",
      "13008",
      "13010",
      "13011",
      "13012",
      "13013",
      "13014",
      "13016",
      "13017",
      "13053",
      "13019",
      "13021",
      "13023",
      "13025",
      "13029",
      "13031",
      "13035",
      "13036",
      "13037",
      "13040",
      "13044",
      "13046",
      "13049"
    ]
  },
  {
    nsi: "30000",
    type: "province",
    color: "#ffe119",
    name: { fr: "Flandre Occidentale", nl: "West-Vlaanderen" },
    chiefTown: { fr: "Bruges", nl: "Brugge" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/a/a3/Wapen_van_West-Vlaanderen.svg",
    wikipedia: "Province_de_Flandre-Occidentale",
    region: "Région Flamande",
    facts: {
      population: 1169990,
      surface: 3144
    },
    children: [
      "31000",
      "31003",
      "31004",
      "31005",
      "31006",
      "31012",
      "31043",
      "31022",
      "31033",
      "31040",
      "31042",
      "34000",
      "34002",
      "34003",
      "34022",
      "34009",
      "34043",
      "34013",
      "34023",
      "34025",
      "34027",
      "34040",
      "34041",
      "34042",
      "32000",
      "32003",
      "32006",
      "32010",
      "32011",
      "32030",
      "38000",
      "38002",
      "38025",
      "38014",
      "38008",
      "38016",
      "35000",
      "35002",
      "35029",
      "35005",
      "35006",
      "35011",
      "35013",
      "35014",
      "36000",
      "36006",
      "36007",
      "36008",
      "36010",
      "36011",
      "36012",
      "36015",
      "36019",
      "37000",
      "37020",
      "37002",
      "37007",
      "37010",
      "37011",
      "37012",
      "37015",
      "37017",
      "37018",
      "33000",
      "33039",
      "33040",
      "33016",
      "33021",
      "33041",
      "33029",
      "33011",
      "33037"
    ]
  },
  {
    nsi: "40000",
    type: "province",
    color: "#4363d8",
    name: { fr: "Flandre Orientale", nl: "Oost-Vlaanderen" },
    chiefTown: { nl: "Gent", fr: "Gand" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/5/51/Wapen_van_Oost-Vlaanderen.svg",
    wikipedia: "Province_de_Flandre-Orientale",
    region: "Région Flamande",
    facts: {
      population: 1454716,
      surface: 2982
    },
    children: [
      "41000",
      "41002",
      "41011",
      "41082",
      "41018",
      "41024",
      "41027",
      "41034",
      "41048",
      "41063",
      "41081",
      "45000",
      "45035",
      "45059",
      "45062",
      "45060",
      "45068",
      "45063",
      "45064",
      "45041",
      "45061",
      "45065",
      "43000",
      "43002",
      "43005",
      "43007",
      "43010",
      "43014",
      "43018",
      "44000",
      "44084",
      "44001",
      "44012",
      "44083",
      "44013",
      "44019",
      "44021",
      "44020",
      "44085",
      "44034",
      "44040",
      "44043",
      "44045",
      "44048",
      "44052",
      "44064",
      "44073",
      "44081",
      "44029",
      "44011",
      "44072",
      "44080",
      "44049",
      "44036",
      "45017",
      "45057",
      "46000",
      "46003",
      "46013",
      "46014",
      "46021",
      "46020",
      "46024",
      "46025",
      "42000",
      "42003",
      "42004",
      "42008",
      "42010",
      "42011",
      "42006",
      "42023",
      "42025",
      "42026",
      "42028"
    ]
  },
  {
    nsi: "70000",
    type: "province",
    color: "#f58231",
    name: { fr: "Limbourg", nl: "Limburg" },
    chiefTown: { fr: "Hasselt", nl: "Hasselt" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/c/cc/Wapen_van_Limburg_%28Belgi%C3%AB%29.svg",
    wikipedia: "Province_de_Limbourg_(Belgique)",
    region: "Région Flamande",
    facts: {
      population: 1454716,
      surface: 2422
    },
    children: [
      "72040",
      "71047",
      "71000",
      "71002",
      "71004",
      "71034",
      "71011",
      "71016",
      "71017",
      "71020",
      "71069",
      "71022",
      "71024",
      "71070",
      "71037",
      "71045",
      "71053",
      "71057",
      "71066",
      "71067",
      "72000",
      "72003",
      "72004",
      "72041",
      "72037",
      "72038",
      "72039",
      "72018",
      "72020",
      "72021",
      "72042",
      "72030",
      "72043",
      "73000",
      "73001",
      "73006",
      "73109",
      "73022",
      "73028",
      "73032",
      "73040",
      "73042",
      "73009",
      "73107",
      "73066",
      "73083",
      "73098"
    ]
  },
  {
    nsi: "20002",
    type: "province",
    color: "#911eb4",
    name: { fr: "Brabant Wallon", nl: "Waals-Brabant" },
    chiefTown: { fr: "Wavre", nl: "Waver" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/1/1c/Wapen_van_Waals-Brabant.svg",
    wikipedia: "Province_du_Brabant_wallon",
    region: "Région Wallonne",
    facts: {
      population: 398990,
      surface: 1091
    },
    children: [
      "25000",
      "25005",
      "25014",
      "25015",
      "25117",
      "25018",
      "25023",
      "25031",
      "25037",
      "25118",
      "25043",
      "25044",
      "25048",
      "25050",
      "25119",
      "25068",
      "25072",
      "25120",
      "25121",
      "25084",
      "25122",
      "25123",
      "25091",
      "25105",
      "25107",
      "25124",
      "25110",
      "25112"
    ]
  },
  {
    nsi: "50000",
    type: "province",
    color: "#46f0f0",
    name: { fr: "Hainaut", nl: "Henegouwen" },
    chiefTown: { fr: "Mons", nl: "Bergen" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/c/c9/H%C3%A9raldique_Province_BE_Hainaut_crown.svg",
    wikipedia: "Province_de_Hainaut",
    region: "Région Wallonne",
    facts: {
      population: 1337759,
      surface: 3786
    },
    children: [
      "51000",
      "51004",
      "51008",
      "51009",
      "51012",
      "51014",
      "51017",
      "51067",
      "55010",
      "51019",
      "51065",
      "51069",
      "55023",
      "51068",
      "55039",
      "52000",
      "52074",
      "52010",
      "52011",
      "52012",
      "52015",
      "52018",
      "52021",
      "52022",
      "52025",
      "52075",
      "52048",
      "52055",
      "53000",
      "53014",
      "53082",
      "53020",
      "53028",
      "53039",
      "53083",
      "53044",
      "53046",
      "53053",
      "53065",
      "53084",
      "53068",
      "53070",
      "55000",
      "55004",
      "55050",
      "55035",
      "55086",
      "52043",
      "55085",
      "52063",
      "55040",
      "56000",
      "56001",
      "56005",
      "56016",
      "56022",
      "56029",
      "56086",
      "56044",
      "56049",
      "56051",
      "56088",
      "56078",
      "57000",
      "57003",
      "57093",
      "57018",
      "57097",
      "54010",
      "57027",
      "57094",
      "57095",
      "57096",
      "54007",
      "57062",
      "57064",
      "57072",
      "57081",
      "58000",
      "58001",
      "55022",
      "58002",
      "56011",
      "58003",
      "56085",
      "58004",
      "56087"
    ]
  },
  {
    nsi: "60000",
    type: "province",
    color: "#f032e6",
    name: { fr: "Liège", nl: "Luik" },
    chiefTown: { fr: "Liège", nl: "Luik" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/e/e5/Blason_liege_prov_crown.svg",
    wikipedia: "Province_de_Liège",
    region: "Région Wallonne",
    facts: {
      population: 1100681,
      surface: 3862
    },
    children: [
      "61000",
      "61003",
      "61079",
      "61010",
      "61012",
      "61080",
      "61019",
      "61024",
      "61028",
      "61031",
      "61039",
      "61041",
      "61043",
      "61048",
      "61081",
      "61063",
      "61068",
      "61072",
      "62000",
      "62003",
      "62006",
      "62009",
      "62011",
      "62015",
      "62119",
      "62022",
      "62026",
      "62027",
      "62032",
      "62120",
      "62038",
      "62118",
      "62051",
      "62060",
      "62063",
      "62121",
      "62079",
      "62093",
      "62096",
      "62099",
      "62100",
      "62122",
      "62108",
      "63000",
      "63001",
      "63003",
      "63004",
      "63012",
      "63087",
      "63013",
      "63020",
      "63023",
      "63035",
      "63038",
      "63040",
      "63045",
      "63046",
      "63048",
      "63049",
      "63057",
      "63058",
      "63088",
      "63061",
      "63067",
      "63072",
      "63073",
      "63075",
      "63076",
      "63089",
      "63086",
      "63079",
      "63080",
      "63084",
      "64000",
      "64008",
      "64015",
      "64021",
      "64023",
      "64076",
      "64025",
      "64029",
      "64034",
      "64047",
      "64056",
      "64063",
      "64065",
      "64074",
      "64075"
    ]
  },
  {
    nsi: "80000",
    type: "province",
    color: "#bcf60c",
    name: { fr: "Luxembourg", nl: "Luxemburg" },
    chiefTown: { fr: "Arlon", nl: "Aarlen" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/e/ed/Coat_of_arms_of_the_Province_of_Luxembourg.svg",
    wikipedia: "Province_de_Luxembourg",
    region: "Région Wallonne",
    facts: {
      population: 281712,
      surface: 4440
    },
    children: [
      "81000",
      "81001",
      "81003",
      "81004",
      "81013",
      "81015",
      "82000",
      "82003",
      "82005",
      "82009",
      "82037",
      "82014",
      "82038",
      "82036",
      "82032",
      "83000",
      "83012",
      "83013",
      "83028",
      "83031",
      "83055",
      "83034",
      "83040",
      "83044",
      "83049",
      "84000",
      "84009",
      "84010",
      "84016",
      "84029",
      "84033",
      "84035",
      "84077",
      "84043",
      "84050",
      "84059",
      "84068",
      "84075",
      "85000",
      "85007",
      "85009",
      "85011",
      "85046",
      "85024",
      "85026",
      "85047",
      "85034",
      "85039",
      "85045"
    ]
  },
  {
    nsi: "90000",
    type: "province",
    color: "#e6beff",
    name: { fr: "Namur", nl: "Namen" },
    chiefTown: { fr: "Namur", nl: "Namen" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/2/2e/Blason_namur_prov_crown.svg",
    wikipedia: "Province_de_Namur",
    region: "Région Wallonne",
    facts: {
      population: 490947,
      surface: 3666
    },
    children: [
      "91000",
      "91005",
      "91013",
      "91015",
      "91030",
      "91034",
      "91054",
      "91059",
      "91142",
      "91064",
      "91072",
      "91103",
      "91114",
      "91120",
      "91143",
      "91141",
      "92000",
      "92003",
      "92006",
      "92035",
      "92138",
      "92045",
      "92048",
      "92142",
      "92054",
      "92140",
      "92141",
      "92087",
      "92094",
      "92097",
      "92101",
      "92137",
      "92114",
      "93000",
      "93010",
      "93014",
      "93018",
      "93022",
      "93056",
      "93090",
      "93088"
    ]
  },
  {
    nsi: "20001",
    type: "province",
    color: "#008080",
    name: { fr: "Brabant Flamand", nl: "Vlaams-Brabant" },
    chiefTown: { nl: "Leuven", fr: "Louvain" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/c/ca/Wapen_van_Vlaams-Brabant.svg",
    wikipedia: "Province_du_Brabant_flamand",
    region: "Région Flamande",
    facts: {
      population: 1094751,
      surface: 2106
    },
    children: [
      "23000",
      "23105",
      "23002",
      "23003",
      "23009",
      "23016",
      "23098",
      "23023",
      "23024",
      "23025",
      "23027",
      "23032",
      "23033",
      "23038",
      "23039",
      "23099",
      "23104",
      "23044",
      "23100",
      "23045",
      "23047",
      "23050",
      "23052",
      "23060",
      "23062",
      "23064",
      "23101",
      "23097",
      "23077",
      "23081",
      "23086",
      "23088",
      "23102",
      "23103",
      "23094",
      "23096",
      "24000",
      "24001",
      "24007",
      "24008",
      "24009",
      "24011",
      "24014",
      "24016",
      "24020",
      "24028",
      "24137",
      "24033",
      "24038",
      "24041",
      "24043",
      "24045",
      "24048",
      "24054",
      "24055",
      "24059",
      "24130",
      "24133",
      "24062",
      "24066",
      "24134",
      "24086",
      "24094",
      "24104",
      "24135",
      "24107",
      "24109"
    ]
  }
];

const regions = [
  {
    nsi: "03000",
    type: "region",
    name: { fr: "Région Wallonne", nl: "Waalse Gewest" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/4/42/Flag_of_Wallonia.svg",
    provinces: ["Brabant wallon", "Hainaut", "Liège", "Luxembourg", "Namur"],
    wikipedia: "Région_wallonne",

    facts: {
      population: 3610089,
      surface: 16845
    },
    children: ["20002", "50000", "60000", "80000", "90000"]
  },
  {
    nsi: "02000",
    type: "region",
    name: { fr: "Région Flamande", nl: "Vlaams Gewest" },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/2/2b/Flag_of_Flanders.svg",
    provinces: [
      "Anvers",
      "Brabant flamand",
      "Flandre occidentale",
      "Flandre orientale",
      "Limbourg"
    ],
    wikipedia: "Région_flamande",
    facts: {
      population: 6509894
    },
    children: ["10000", "70000", "40000", "20001", "30000"]
  },
  {
    nsi: "04000",
    type: "region",
    name: {
      fr: "Région Bruxelles-Capitale",
      nl: "Brussels Hoofdstedelijk Gewest"
    },
    armories:
      "https://upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_the_Brussels-Capital_Region.svg",
    provinces: ["Bruxelles capitale"],
    wikipedia: "Région_de_Bruxelles-Capitale",
    facts: {
      population: 1183545
    }
  }
];

export default provinces.concat(regions);
